import { render, staticRenderFns } from "./step-2.vue?vue&type=template&id=7d654442&"
import script from "./step-2.vue?vue&type=script&lang=js&"
export * from "./step-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d654442')) {
      api.createRecord('7d654442', component.options)
    } else {
      api.reload('7d654442', component.options)
    }
    module.hot.accept("./step-2.vue?vue&type=template&id=7d654442&", function () {
      api.rerender('7d654442', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/pages/step-2.vue"
export default component.exports